module.exports = __webpack_public_path__ + "static/img/bg-02.a5dab23.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/bg-02.png
// module id = Uy6L
// module chunks = 65